import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { doDoorKnock, doImageShake, doTakePhoto, doTransition, doWaitImageByTime, isAnnGFAndCorrupted, isMCFlirtingWithAlex } from "../helpers/helpers";
import { V9AlexDateAfter } from "./V9";
import { alex } from "../characters/Alex";
import { stranger } from "../characters/Stranger";
import { alexImages } from "../helpers/alexInstaImages";
import { Phone } from "../../src/components/phoneUI/PhoneClass";

const v9 = images.v9;
export const V9AlexDate = async (): Promise<any> => {
    doTransition(v9.V9Morning2);
    mc.think(`Let's see when Alex is free.`);
    await Phone.showMessagesUI({ name: alex.name }, async () => {
        Phone.setMessage({ character: mc.character, text: `Hey`, options: { wait: false } });
        Phone.setMessage({ character: alex.character, text: `WOW! I was just picking up the phone to text you!` });
        Phone.setMessage({ character: mc.character, text: `Damn... I should have waited.` });
        Phone.setMessage({ character: alex.character, text: `😉` });
        Phone.setMessage({ character: alex.character, text: `I guess we should set up a date or Ann would kill us...` });
        Phone.setMessage({ character: mc.character, text: `Yeah. It seems like it.` });
        Phone.setMessage({ character: alex.character, text: `Hmmm... How about tonight?` });
        Phone.setMessage({ character: mc.character, text: `Let me check my schedule...` });
        Phone.setMessage({ character: alex.character, text: `😔` });
        Phone.setMessage({ character: mc.character, text: `Lol. Tonight will be great.` });
        Phone.setMessage({ character: alex.character, text: `🥳` });
        Phone.setMessage({ character: mc.character, text: `Are we gonna transition to talking only using emojis?` });
        if (isMCFlirtingWithAlex()) {
            Phone.setMessage({ character: alex.character, text: `🤨` });
            Phone.setMessage({ character: mc.character, text: `🍆` });
            Phone.setMessage({ character: alex.character, text: `😋` });
            Phone.setMessage({ character: mc.character, text: `💦` });
            Phone.setMessage({ character: alex.character, text: `🤣` });
        }

        Phone.setMessage({ character: alex.character, text: `Ok ok, so going back to tonight, there's one thing I gotta mention...` });
        Phone.setMessage({ character: alex.character, text: `There's an outfit I gotta promote... You know... Insta (aka work) stuff.` });
        Phone.setMessage({ character: alex.character, text: `It's a bit revealing... I hope that's fine by you.` });
        Phone.setMessage({ character: mc.character, text: `Damn... I was really counting on you dressing up in a lab coat.` });
        Phone.setMessage({ character: alex.character, text: `Lol! Next time 🤭` });
        Phone.setMessage({ character: alex.character, text: `That means you're ok with that... Right?` });
        Phone.setMessage({ character: mc.character, text: `Of course!` });
        Phone.setMessage({ character: alex.character, text: `GREAT! So I'll see you later! 😘` });
        Phone.closeMessagesUI();
    });

    doTransition(v9.V9MCRoomBeforeAlexDate_1, null, 2);
    mc.think(`It's time.`);

    doTransition(v9.V9AlexBeforeDateFrontDoor_0, null, 2);
    mc.think(`Okay. Here we go.`);
    doWaitImageByTime(v9.V9AlexBeforeDateFrontDoor_4);
    doDoorKnock();
    doWaitImageByTime(v9.V9AlexBeforeDateFrontDoor_1);
    alex.talk(`Hey!`);
    await alex.setQuestion(new Question({ text: `Hey!`, options: { think: false }, key: `v9AlexDateDoorComplimentedHer` })
        .option({ title: "Compliment her", key: true })
        .option({ title: "Don't compliment her", key: false }));

    if (Question.globalAnswers.v9AlexDateDoorComplimentedHer) {
        await mc.set((properties) => {
            properties.alexRelationship += 3;
        });
        mc.talk(`Wow! You look... Incredible!`);
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_2);
        mc.talk(`This outfit is sexy as hell!`);
        mc.talk(`They're going to run out of stock in no time!`);
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_5);
        alex.talk(`Thank you!`);
        alex.talk(`I know it's a bit revealing... But whatever.`);
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_6);
        mc.talk(`I've never noticed you have tan lines.`);
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_5);
        alex.talk(`I decided to spend some time at the beach and this is the result...`);

        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_6);
        alex.talk(`You are very handsome as well!`);
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_3);
        mc.talk(`Thanks!`);

    } else {
        ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_6);
        mc.talk(`Hey.`);
    }
    ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_6);
    mc.talk(`Ready to go?`);
    ImageClass.setImage(images.v9.V9AlexBeforeDateFrontDoor_5);
    alex.talk(`Absolutely!`);

    doTransition(v9.V9AlexDateBefore_2);
    alex.talk(`The weather is so nice! I'm happy we decided to go on foot!`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_0);
    mc.talk(`Are we going to talk about the weather so soon? I thought we're going to save it for later?`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_3);
    alex.talk(`Haha! It's not like I don't have anything else to say! IT IS a really nice weather.`);
    mc.talk(`Haha, I'm just pulling your leg...`);
    if (mc.properties.alexRelationship > 4) {
        mc.think(`Actually... I'd like to pull something else in bed.`);
    }

    ImageClass.setImage(images.v9.V9AlexDateBefore_2);
    alex.talk(`You know... I can't believe Ann pulled that off.`);
    alex.talk(`I honestly thought she is fucking with me when she suggested it.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_0);
    mc.talk(`I agree, it came out of the blue, I honestly wouldn't have guessed it if she let me.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_2);
    alex.talk(`Either way, I'm glad she suggested it...`);
    alex.talk(`You are a curious guy, I wanted to spend more time with you.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_5);
    alex.talk(`And now I don't have to worry about doing it behind Ann's back.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_4);
    alex.talk(`Don't get me wrong! I know it's a one time thing! I mean as a friend.`);
    if (mc.properties.alexRelationship > 4) {
        mc.think(`Sure...`);
    }
    ImageClass.setImage(images.v9.V9AlexDateBefore_6);
    alex.talk(`Jeez... That's not exactly what I wanted to say.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_7);
    alex.talk(`It sounded better in my head!`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_10);
    mc.talk(`That's fine! I understand completely what you mean.`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_8);
    alex.talk(`You do?`);
    ImageClass.setImage(images.v9.V9AlexDateBefore_9);
    alex.talk(`Phew...`);
    doWaitImageByTime(v9.V9AlexDateBefore_1);
    mc.talk(`Here we are!`);

    return jump(V9AlexDateRestaurant, `V9AlexDateRestaurant`);
};

export const V9AlexDateRestaurant = async (): Promise<any> => {
    doWaitImageByTime(images.v9.V9AlexDate_6);
    alex.talk(`Oh wow! This place looks amazing!`);
    ImageClass.setImage(images.v9.V9AlexDate_5);
    alex.talk(`It looks really expensive though!`);
    mc.talk(`Don't worry, it all taken care of.`);
    ImageClass.setImage(images.v9.V9AlexDate_17);
    alex.talk(`What? No!`);
    ImageClass.setImage(images.v9.V9AlexDate_18);
    mc.talk(`Are you forgetting it's supposed to be a real date?`);
    mc.talk(`Do you usually split the bill when going out on dates?`);
    ImageClass.setImage(images.v9.V9AlexDate_4);
    alex.talk(`Yeah, you're right.`);
    mc.talk(`Come-on Alex! You need to take this date more seriously!`);
    ImageClass.setImage(images.v9.V9AlexDate_6);
    alex.talk(`Haha, sorry! I will from now on, I promise.`);

    ImageClass.setImage(images.v9.V9AlexDate_5);
    alex.talk(`I still can't believe how nice it is here!`);
    ImageClass.setImage(images.v9.V9AlexDate_6);
    alex.talk(`Do you mind taking a picture of me?`);
    ImageClass.setImage(images.v9.V9AlexDate_4);
    alex.talk(`I need it for Insta.`);
    ImageClass.setImage(images.v9.V9AlexDate_6);
    alex.talk(`You know... That's the requirement of getting paid.`);
    ImageClass.setImage(images.v9.V9AlexDate_2);
    mc.talk(`Of course not.`);
    doWaitImageByTime(images.v9.V9AlexDate_3, { wait: true });
    ImageClass.setImage(images.v9.V9AlexDate_19, { wait: true });
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDate_19);
    await mc.setQuestion(new Question({ text: `Maybe...`, options: { think: true }, key: `v9AlexDateRiskyPhoto` })
        .option({ title: `Suggest taking a Risky picture`, key: true })
        .option({ title: `Continue the evening`, key: false }));


    ImageClass.setImage(images.v9.V9AlexDate_6);
    alex.talk(`Thank you!`);
    if (Question.globalAnswers.v9AlexDateRiskyPhoto) {
        ImageClass.setImage(images.v9.V9AlexDate_2);
        mc.talk(`That was nice... But I was sure you're going to pose like you usually do on your Insta.`);
        ImageClass.setImage(images.v9.V9AlexDate_9);
        alex.talk(`Haha, I know what you mean! But I can't do that here!`);
        mc.talk(`Why not?`);
        ImageClass.setImage(images.v9.V9AlexDate_5);
        alex.talk(`I don't know... This place seems too high-class for that.`);
        ImageClass.setImage(images.v9.V9AlexDate_18);
        mc.talk(`I disagree.`);
        mc.talk(`Besides... I bet it's going to gain tons of likes.`);
        ImageClass.setImage(images.v9.V9AlexDate_4);
        alex.talk(`Hmm...`);
        ImageClass.setImage(images.v9.V9AlexDate_5);
        alex.talk(`Fine! But quickly! I don't want to be the reason we get kicked out.`);
        ImageClass.setImage(images.v9.V9AlexDate_4);
        alex.talk(`Ready?`);
        mc.talk(`Go for it.`);
        doWaitImageByTime(images.v9.V9AlexDate_8);
        mc.think(`Damn, she is so hot...`);
        ImageClass.setImage(images.v9.V9AlexDate_7, { wait: true });
        doTakePhoto();
        ImageClass.setImage(images.v9.V9AlexDate_7, { wait: true });
        ImageClass.setImage(images.v9.V9AlexDate_10);

    } else {
        ImageClass.setImage(images.v9.V9AlexDate_15);

    }
    return jump(V9AlexDateRestaurant_2, "V9AlexDateRestaurant_2");

};
export const V9AlexDateRestaurant_2 = async (): Promise<any> => {
    await stranger.set((properties) => {
        stranger.name = "Waiter";
    });

    stranger.talk(`Good evening my name is Jacob and I'd be your waiter.`);
    await stranger.set((properties) => {
        stranger.name = "Jacob";
    });
    mc.talk(`Hey.`);
    doWaitImageByTime(images.v9.V9AlexDate_15);
    stranger.talk(`Would you like to open with our special wine?`);
    mc.talk(`Yes, we'd like that.`);
    stranger.talk(`Excellent choice!`);
    doWaitImageByTime(images.v9.V9AlexDate_13);
    stranger.talk(`For the lady.`);
    doWaitImageByTime(images.v9.V9AlexDate_14);
    stranger.talk(`And for the gentleman.`);
    ImageClass.setImage(images.v9.V9AlexDate_15);
    stranger.talk(`Enjoy. I'll take your order in a few minutes.`);

    if (Question.globalAnswers.v9AlexDateRiskyPhoto) {
        ImageClass.setImage(images.v9.V9AlexDate_9);
        alex.talk(`Haha! I can't believe the timing on him! I almost got caught!`);
        mc.talk(`But you didn't!`);
        mc.talk(`And now you have a picture that will go viral.`);
        ImageClass.setImage(images.v9.V9AlexDate_6);
        alex.talk(`I don't know about that but thank you! Haha.`);
    }

    // doing cheers with the wine
    ImageClass.setImage(images.v9.V9AlexDate_21);
    alex.talk(`I think now we can really start the night!`);
    alex.talk(`Cheers!`);
    ImageClass.setImage(images.v9.V9AlexDate_22);
    mc.talk(`Cheers!`);
    ImageClass.setImage(images.v9.V9AlexDate_2);
    mc.talk(`I just hope this night won't end like the last time I drank white wine.`);
    ImageClass.setImage(images.v9.V9AlexDate_23);
    alex.talk(`Why, what happened?`);
    mc.talk(`Nah... The story is too crazy for me to tell.`);
    ImageClass.setImage(images.v9.V9AlexDate_24);
    alex.talk(`Oh my god! You can't do that!`);
    ImageClass.setImage(images.v9.V9AlexDate_23);
    alex.talk(`Now you have to tell me!`);
    mc.talk(`Haha.`);

    ImageClass.setImage(images.v9.V9AlexDate_2);
    mc.talk(`So, this one night, my best friend Joey and I were chilling at my house, playing video games.`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`Joey, being Joey, started getting hungry, so I sent him to the kitchen to find something to eat.`);
    mc.talk(`Instead of food, Joey found my parents' wine stash...`);
    ImageClass.setImage(images.v9.V9AlexDate_26);
    mc.talk(`He came back with two bottles of wine.`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`You surely sent him back with those, right?`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`It wouldn't be a real story if I had, would it?`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`Haha, carry on.`);

    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`For some reason, we thought it'd be a good idea to race and see who could finish his bottle first.`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`Who won?`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`It was a tie...`);
    mc.talk(`Anyway, for reasons I can't explain, we then walked outside and decided to sneak into our elementary school.`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`Of all places?`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`Alex, don't try to understand the motives of a young man who just chugged an entire bottle of wine.`);
    ImageClass.setImage(images.v9.V9AlexDate_28);
    alex.talk(`Haha.`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`So there I was, climbing the fence, when I hear this rrrip! My pants tore, right in the back.`);
    ImageClass.setImage(images.v9.V9AlexDate_26);
    mc.talk(`Joey laughed, but I said, 'Screw it! Who cares, no one's around anyway.'`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`While we were walking through the empty halls, we started hearing noises of people.`);
    ImageClass.setImage(images.v9.V9AlexDate_29);
    alex.talk(`No way!`);
    // TODO: maybe lower the glass wine as she drinks
    mc.talk(`Of all the days, we picked one with a parent-teacher meeting.`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`You're kidding!`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`Yup.`);
    ImageClass.setImage(images.v9.V9AlexDate_26);
    mc.talk(`At first, I tried to act like I belonged there.`);
    mc.talk(`But I was too drunk to even come close.`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`And my torn pants weren't helping my case at all.`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`What did you do?`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`I started running all the way home, feeling the breeze on my cheeks.`);
    ImageClass.setImage(images.v9.V9AlexDate_28);
    alex.talk(`Hahaha! That's the best story I've heard in a while!`);
    ImageClass.setImage(images.v9.V9AlexDate_27);
    alex.talk(`Wait...`);
    alex.talk(`Where was Joey this whole time?`);
    ImageClass.setImage(images.v9.V9AlexDate_25);
    mc.talk(`He hid in the janitor's closet.`);
    mc.talk(`When I think of it. Until this day he refuses to tell me how exactly he managed to stay there for so many hours.`);

    ImageClass.setImage(images.v9.V9AlexDate_26);
    mc.talk(`Now it's your turn.`);
    ImageClass.setImage(images.v9.V9AlexDate_30);
    alex.talk(`Hmm...`);
    ImageClass.setImage(images.v9.V9AlexDate_31);
    alex.talk(`To be honest... I can't think of anything.`);
    ImageClass.setImage(images.v9.V9AlexDate_30);
    mc.talk(`Really? With all the photos you upload to Insta from so many places, I would have bet you have some crazy stories.`);
    ImageClass.setImage(images.v9.V9AlexDate_31);
    alex.talk(`Yeah... But no.`);
    mc.talk(`It's fine, forget it! Let's just enjoy the rest of the evening.`);

    doTransition(images.v9.V9AlexDate_32);
    alex.talk(`The food was so good!!!`);
    alex.talk(`My belly... I feel like I'm going to explode.`);
    alex.talk(`Too bad I can't eat here every day!`);
    ImageClass.setImage(images.v9.V9AlexDate_33);
    mc.talk(`You already bought a house, I'm sure one day you will!`);
    ImageClass.setImage(images.v9.V9AlexDate_34);
    alex.talk(`Haha, I wish!`);

    ImageClass.setImage(images.v9.V9AlexDate_35);
    alex.talk(`Oh wow! Look at that sunset!`);
    alex.talk(`It's beautiful!`);
    ImageClass.setImage(images.v9.V9AlexDate_33);
    alex.talk(`I could look at it for hours.`);
    ImageClass.setImage(images.v9.V9AlexDate_35);
    mc.talk(`The night is still young, let's go take a closer look.`);
    ImageClass.setImage(images.v9.V9AlexDate_33);
    alex.talk(`I'm on board!`);

    return jump(V9AlexDateAfterRestaurant, "V9AlexDateAfterRestaurant");

};
export const V9AlexDateAfterRestaurant = async (): Promise<any> => {
    doTransition(images.v9.V9AlexDateAfterWalk_3);
    alex.talk(`Wow...`);
    await alex.setQuestion(new Question({ text: `Isn't it stunning?`, options: { think: true }, key: `v9AlexDateSunsetLookedAtAlex` })
        .option({ title: `Refer to Alex`, key: true })
        .option({ title: `Refer to the sunset`, key: false }));

    if (Question.globalAnswers.v9AlexDateSunsetLookedAtAlex) {
        await mc.set((properties) => {
            properties.alexRelationship += 3;
        });
    }

    mc.talk(`It really is.`);
    alex.talk(`Any guy wanting to impress a girl should bring her here.`);

    ImageClass.setImage(images.v9.V9AlexDateAfterWalk_7);
    alex.talk(`Oh, look over there! A telescope!`);
    ImageClass.setImage(images.v9.V9AlexDateAfterWalk_6);
    mc.talk(`Let's go check it out.`);
    doWaitImageByTime(v9.V9AlexDateAfterWalk_8);
    mc.talk(`Be careful, the warning says, "Do not point at the sun."`);
    ImageClass.setImage(images.v9.V9AlexDateAfterWalk_4);
    alex.talk(`No need to worry, I'm looking for something else.`);
    mc.talk(`Hmm... What's that?`);
    alex.talk(`I'm checking if any guy is sealing the deal right now. Haha!`);
    mc.talk(`I didn't take you for a peeping tom.`);
    ImageClass.setImage(images.v9.V9AlexDateAfterWalk_8);
    alex.talk(`Sometimes... Can you really blame me? This is so tempting!`);
    mc.talk(`So? Are there any naughty people down there?`);
    ImageClass.setImage(images.v9.V9AlexDateAfterWalk_4);
    alex.talk(`No... But I found something better!`);
    mc.talk(`What can possibly be better?`);
    doWaitImageByTime(images.v9.V9AlexDateAfterWalk_5);
    alex.talk(`A pier!`);
    doWaitImageByTime(images.v9.V9AlexDateAfterWalk_8);
    alex.talk(`What do you say? Do you still have some energy left?`);
    mc.talk(`Of course!`);
    return jump(V9AlexDateAfterPier, "V9AlexDateAfterPier");
};

export const V9AlexDateAfterPier = async (): Promise<any> => {
    doTransition(v9.V9AlexDateAfter_2);
    mc.think(`Hmm...`);
    mc.think(`Why does she look sad all of a sudden? I thought we were having a wonderful evening.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_3);
    mc.talk(`Alex? Is something wrong?`);
    alex.talk(`Yeah, sorry! I mean, no. Everything is fine, I was just thinking.`);
    mc.talk(`Is it something I did?`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_4);
    alex.talk(`Absolutely not! Oh, sorry. I didn't mean to snap. I'm just ruining the evening, aren't I?`);
    mc.talk(`Not at all.`);
    mc.talk(`But... Tell me... What's on your mind?`);

    doWaitImageByTime(images.v9.V9AlexDateAfter_44);
    alex.talk(`...`);
    alex.talk(`I was just thinking about that story you told me in the school...`);
    mc.talk(`Damn, I didn't realize that story was so upsetting.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_5);
    alex.talk(`Haha... No, it's not that.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_4);
    alex.talk(`It's just... when you asked me to tell a similar story, I couldn't think of anything.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_44);
    alex.talk(`I wish I had even one funny story to share.`);
    alex.talk(`And it brings me back to the conversation we had in my room...`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_4);
    alex.talk(`I'm so busy trying to show the world something, but I'm not sure it's real.`);
    alex.talk(`I mean, it's somewhat real because it's part of my life...`);
    alex.talk(`But it usually involves going to nice places, taking some pictures, and posting them right away.`);
    alex.talk(`Sometimes, I don't even realize how beautiful the place is until I see it on my Insta the next day.`);

    ImageClass.setImage(images.v9.V9AlexDateAfter_45);
    alex.talk(`Damn, I'm sorry. I'm actually ruining a perfect night!`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_46);
    mc.talk(`Not at all. I'd rather you be honest than fake anything.`);
    mc.talk(`So tell me, what would you change in your life right now?`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_4);
    alex.talk(`Right now? I just wish I had a crazy story to tell.`);
    doWaitImageByTime(v9.V9AlexDateAfter_6);
    alex.talk(`You know what?`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_7);
    alex.talk(`I can change that right now!`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_8);
    mc.think(`Oh... What is she going to do?`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_9);
    alex.talk(`This will make a great story!`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_10);
    alex.talk(`La la la...`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_11);
    alex.talk(`GERONIMO!`);
    // TODO: splash sound
    doImageShake(v9.V9AlexDateAfter_12, { wait: true });
    doWaitImageByTime(v9.V9AlexDateAfter_13);
    await alex.setQuestion(new Question({ text: `Oh my! The water is so nice!`, options: { think: false }, key: `v9AlexDateAfterJoinedHerWater` })
        .option({ title: `Join her`, key: true })
        .option({ title: `Don't join her`, key: false }));

    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        await mc.set((properties) => {
            properties.alexRelationship += 5;
        });
        return jump(V9AlexDateAfterRestaurant_JoinedHer, "V9AlexDateAfterRestaurant_JoinedHer");
    }

    mc.talk(`Take your time, I'll be waiting right here.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_14);
    alex.talk(`Oh...`);
    alex.talk(`Okay... I'll be right out.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_15);
    alex.think(`Blop!`);
    return jump(V9AlexDate_Home, "V9AlexDate_Home");
};
export const V9AlexDateAfterRestaurant_JoinedHer = async (): Promise<any> => {
    mc.talk(`You don't have to tell me twice!`);
    mc.talk(`Make way!`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_43);
    mc.talk(`CANNON BALL!!!`);
    doImageShake(images.v9.V9AlexDateAfter_42);
    alex.talk(`Ahh!!! Haha!`);

    doWaitImageByTime(v9.V9AlexDateAfter_0);
    mc.talk(`The water's incredible, just like this evening.`);
    doWaitImageByTime(v9.V9AlexDateAfter_47);
    alex.talk(`Yeah, it is... I'm really happy you're here with me.`);

    ImageClass.setImage(images.v9.V9AlexDateAfter_0);
    mc.talk(`How could I resist? Being part of your 'crazy moment' is the best part of my day.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_47);
    alex.talk(`You have this... remarkable way of making everything better, you know?`);

    ImageClass.setImage(images.v9.V9AlexDateAfter_16);
    alex.talk(`When you first arrived, I couldn't imagine how this night would unfold.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_1);
    alex.talk(`But now... it's exceeded everything I could have hoped for.`);

    alex.talk(`I wish we could stay like this... forever.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_1);
    mc.think(`Seeing her against the backdrop of the sunset, it's hard not to feel like this is exactly where I belong.`);

    doWaitImageByTime(images.v9.V9AlexDateAfter_0);
    alex.talk(`${mc.name}? Can I... try something?`);
    mc.talk(`For you, anything.`);

    doWaitImageByTime(images.v9.V9AlexDateAfter_1);
    mc.think(`Alex gave me that look, and I knew what was coming.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_17);
    mc.think(`She jumped into my arms, and we both started kissing like in those romance films.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_18);
    mc.think(`Did Ann see this coming? Did she somehow know we'd click this way?`);
    mc.think(`Makes me wonder if she planned all this.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_19);
    mc.think(`It felt right. It felt perfect.`);
    mc.think(`And it felt like that's how it was meant to be.`);
    doWaitImageByTime(v9.V9AlexDateAfter_48);
    alex.talk(`Wow... This is... Perfect.`);
    alex.talk(`I think I need to cool off a bit.`);
    mc.think(`You and me both.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_20);
    mc.think(`Alex climbed the ladder and I couldn't stop myself from admiring her body.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_22);
    mc.think(`I definitely need to cool off...`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_21);
    mc.think(`The sight is unforgettable. She's as breathtaking as the sunset itself.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_23);
    mc.think(`I followed right behind and joined her back on the pier.`);
    mc.think(`My eyes were fixated on her magnificent ass.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_25);
    mc.think(`There she was, standing on the pier, sunlight catching her hair.`);
    alex.talk(`Wow... I needed that.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_26);
    await alex.setQuestion(new Question({ text: `I'm having so much fun I don't want the night to end...`, options: { think: false }, key: `v9AlexDateExposedHerBreasts` })
        .option({ title: `Move her hand`, key: true })
        .option({ title: `Go back home`, key: false }));

    if (!Question.globalAnswers.v9AlexDateExposedHerBreasts) {
        mc.talk(`Me too... But unfortunately, like all good things, this must come to an end.`);
        return jump(V9AlexDate_Home, "V9AlexDate_Home");
    }

    mc.talk(`You are beautiful, Alex, you don't need to keep hiding yourself.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_27);
    mc.talk(`Every part of your body should be admired.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_28);
    mc.think(`Alex didn't resist. She let me move her arm away from her breasts as if she was waiting for me to do it.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_29);
    mc.think(`She was standing there, only a thong covering her body.`);
    ImageClass.setImage(images.v9.V9AlexDateAfter_30);
    mc.think(`The magnificent breasts she keeps hiding from the world are right there for me to see.`);
    mc.think(`The way the water drops were dripping down her chest... I could look at this for hours.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_31);
    mc.talk(`Doesn't it feel better?`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_32);
    mc.think(`Without saying anything, Alex jumped into my arms again.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_33);
    mc.think(`We started kissing again like we hadn't just kissed a moment ago.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_34);
    mc.think(`It feels so right; I can't accept that this date is not real.`);

    doWaitImageByTime(images.v9.V9AlexDateAfter_31);
    alex.talk(`This is a night I'll remember my entire life.`);
    mc.talk(`Me too.`);
    mc.talk(`And I can't fight the urge to capture you like this.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_49);
    alex.talk(`I'd love to.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_35);
    mc.think(`Alex channeled her inner model and struck a pose right away.`);
    mc.talk(`Wow, this is just perfect.`);
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_35);

    mc.think(`You can tell she has experience.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_36, { wait: true });
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_36);
    mc.think(`She definitely is in her zone.`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_37);
    mc.think(`I'm holding myself back not to jump on her right now.`);
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_37);
    if (isAnnGFAndCorrupted()) {
        mc.think(`I only took some photos of Ann. I hope I'm doing a good job.`);
    } else {
        mc.think(`I hope I'm doing a good job.`);
    }
    doWaitImageByTime(images.v9.V9AlexDateAfter_38);
    mc.talk(`You look amazing.`);
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_38, { wait: true });
    // Same angle as above but focus on her face (can see her breasts)
    doWaitImageByTime(images.v9.V9AlexDateAfter_39);
    mc.think(`I could look at those breasts for hours...`);
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_39, { wait: true });
    mc.talk(`I can see you're in your model zone; how about a little smile for me?`);
    doWaitImageByTime(images.v9.V9AlexDateAfter_40);
    alex.talk(`Haha, yeah, sorry. You're not wrong... I was in my zone.`);
    mc.talk(`Stay like this! This is perfect.`);
    doTakePhoto();
    ImageClass.setImage(images.v9.V9AlexDateAfter_40);
    await mc.setQuestion(new Question({ text: `I wonder if I should suggest one last photo for her Insta...`, options: { think: true }, key: `v9AlexDatePierTookInstaPhoto` })
        .option({ title: `Suggest it`, key: true })
        .option({ title: `Don't suggest`, key: false }));

    if (Question.globalAnswers.v9AlexDatePierTookInstaPhoto) {
        mc.talk(`And what do you say, last one for your Insta?`);
        doWaitImageByTime(alexImages.Alex47);
        mc.think(`Alex covered her breasts and fixed her hair.`);
        mc.think(`It was obvious that looking good on her Insta was important to her.`);
        doTakePhoto();
        doWaitImageByTime(alexImages.Alex47);
        mc.think(`Even though I had just seen her breasts in all their glory, there was still something intriguing about her covering them.`);
    }

    mc.talk(`That's it. I think we are done here.`);
    return jump(V9AlexDate_Home, "V9AlexDate_Home");
};


export const V9AlexDate_Home = async (): Promise<any> => {
    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        doTransition(v9.V9AlexDateAfterFrontDoor_2);
    } else {
        doTransition(v9.V9AlexDateAfterFrontDoor_0);
    }
    alex.talk(`Here we here...`);
    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        alex.talk(`I had an unforgettable night!`);
        ImageClass.setImage(images.v9.V9AlexDateAfterFrontDoor_1);
        mc.talk(`Me too.`);
        doWaitImageByTime(v9.V9AlexDateAfterFrontDoor_3);
        mc.think(`Me and Alex kept kissing for a while outside her door...`);
        mc.think(`Even though we just had our first kiss not long ago it already felt natural.`);
        doWaitImageByTime(v9.V9AlexDateAfterFrontDoor_4);
        mc.think(`I can feel her heart beating.`);
        doWaitImageByTime(v9.V9AlexDateAfterFrontDoor_5);
        mc.think(`And so is mine.`);
        doWaitImageByTime(v9.V9AlexDateAfterFrontDoor_2);
        alex.talk(`Thank you again ${mc.name}.`);
        alex.talk(`When I stepped out the door I couldn't imagine how great this night will be.`);
        doWaitImageByTime(v9.V9AlexDateAfterFrontDoor_6);
        alex.talk(`You know...`);
        alex.talk(`I told Ann that I'll treat it like any other date and won't hold myself back from doing things I want...`);
        alex.talk(`But I think it would be wrong...`);
        alex.talk(`On other circumstances I would have invited you in...`);
        mc.think(`FUCK!`);
        ImageClass.setImage(v9.V9AlexDateAfterFrontDoor_7);
        mc.talk(`I totally agree.`);
        ImageClass.setImage(v9.V9AlexDateAfterFrontDoor_6);
        alex.talk(`Good night ${mc.name}.`);


    } else {
        alex.talk(`Thank you for taking me out.`);
        alex.talk(`I had a great night.`);
        ImageClass.setImage(images.v9.V9AlexDateAfterFrontDoor_8);
        mc.talk(`Me too.`);
        mc.talk(`Good night Alex.`);
        alex.talk(`Good night.`);
        doWaitImageByTime(images.v9.V9AlexDateAfterFrontDoor_9);
        alex.talk(`Muah!`);
    }
    return jump(V9AlexDateEnd, "V9AlexDateEnd");
};
export const V9AlexDateEnd = async (): Promise<any> => {
    return jump(V9AlexDateAfter, "V9AlexDateAfter");
};